
export function indefiniteArticle(text) {
  let indefiniteArticle = 'a';

  if (/^[aeiou]/i.test(text)) {
    indefiniteArticle = 'an';
  }

  return indefiniteArticle;
}